import { fetchEarlyAccessData } from './fetchEarlyAccessData';
import { dealTypeFromJsonQuery, isFlat, offerTypeFromJsonQuery, TJsonQuery } from '../../../packages/JsonQuery';
import { IApplicationContext } from 'shared/types/applicationContext';
import { EDealType } from 'shared/types/dealType';
import { IEarlyAccess } from 'shared/types/earlyAccess/earlyAccess';

interface IParameters {
  jsonQuery: TJsonQuery;
  regionId: number;
}

export async function fetchEarlyAccessDataIfNeeded(
  context: IApplicationContext,
  { jsonQuery, regionId }: IParameters,
): Promise<IEarlyAccess | null> {
  const { config } = context;

  const earlyAccessEnabledByFeatureToggle = Boolean(config.get<boolean>('BX.EarlyAccess.Enabled'));

  const availableRegions = config.get<number[]>('BX.EarlyAccess.AvailableRegions') || [2];
  const earlyAccessEnabledForRegion = availableRegions.includes(regionId);

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const earlyAccessEnabledByType = dealType === EDealType.RentLongterm && isFlat(offerType);

  if (!earlyAccessEnabledByFeatureToggle || !earlyAccessEnabledByType || !earlyAccessEnabledForRegion) {
    return null;
  }

  return fetchEarlyAccessData(context);
}
